module.exports = __webpack_public_path__ + "assets/img/yxms.5b4b5265.png";